import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {NgMarkdownEditorComponent} from "./ng-markdown-editor.component";
import {MarkdownModule, MarkedOptions, MarkedRenderer} from "ngx-markdown";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AngularMarkdownEditorModule} from "./lib/angular-markdown-editor/angular-markdown-editor.module";
import {TemplateComponent} from "./template/template.component";
import {ReactiveComponent} from "./reactive/reactive.component";
import {NgMarkdownSampleComponent} from "./ng-markdown-sample.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MarkdownModule,
        MarkdownModule.forRoot({
            provide: MarkedOptions,
            useFactory: (): MarkedOptions => {
                return {
                    renderer: new MarkedRenderer(),
                    gfm: true,
                    tables: true,
                    breaks: false,
                    pedantic: false,
                    sanitize: false,
                    smartLists: true,
                    smartypants: false,
                };
            },
        }),
        ReactiveFormsModule,
        // AngularMarkdownEditorModule,
        AngularMarkdownEditorModule.forRoot({
            // add any Global Options/Config you might want
            // to avoid passing the same options over and over in each components of your App
            iconlibrary: "glyph"
        })
    ],
    declarations: [
        NgMarkdownEditorComponent,
        NgMarkdownSampleComponent,
        ReactiveComponent,
        TemplateComponent
    ],
    providers: [
        {
            provide: MarkedOptions,
            useFactory: (): MarkedOptions => {
                return {
                    renderer: new MarkedRenderer(),
                    gfm: true,
                    tables: true,
                    breaks: false,
                    pedantic: false,
                    sanitize: true,
                    smartLists: true,
                    smartypants: false,
                };
            },
        },
        {
            provide: "config",
            useValue: {
                iconlibrary: "glyph"
            }
        },
        {
            provide: "markDownConfig",
            useValue: {
                iconlibrary: "fa"
            }
        },
        {
            provide: "markDownLocale",
            useValue: {
                language: "en",
                dictionary: {
                    "Bold": "Bold",
                    "Italic": "Italic",
                    "Heading": "Heading",
                    "URL/Link": "URL/Link",
                    "Image": "Image",
                    "List": "List",
                    "Ordered List": "Ordered List",
                    "Unordered List": "Unordered List",
                    "Code": "Code",
                    "Quote": "Quote",
                    "Preview": "Preview",
                    "Strikethrough": "Strikethrough",
                    "Table": "Table",
                    "strong text": "strong text",
                    "emphasized text": "emphasized text",
                    "heading text": "heading text",
                    "enter link description here": "enter link description here",
                    "Insert Hyperlink": "Insert Hyperlink",
                    "enter image description here": "enter image description here",
                    "Insert Image Hyperlink": "Insert Image Hyperlink",
                    "enter image title here": "enter image title here",
                    "list text here": "list text here"
                }
            }
        }
    ],
    exports: [
        NgMarkdownEditorComponent,
        NgMarkdownSampleComponent,
    ]
})
export class NgMarkdownEditorModule {
}

